import React, { SetStateAction } from 'react';
import { GoAlert } from 'react-icons/go';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import ContainerModal from 'components/Modal';
import { UseTranslationProps } from 'types/UseTranslationProps';

interface ConfirmScreenProps {
	isOpen: boolean;
	setIsOpen: React.Dispatch<SetStateAction<boolean>>;
	functionToExecOnConfirm: any;
	title: string;
	buttonClose: boolean;
	message: JSX.Element;
	functioToExecOnClose?: any;
}

export default function ConfirmScreen({
	isOpen,
	setIsOpen,
	title,
	buttonClose,
	message,
	functionToExecOnConfirm,
	functioToExecOnClose = () => {}
}: ConfirmScreenProps) {
	const { t }: UseTranslationProps = useTranslation();

	return (
		<ContainerModal
			isOpenProps={isOpen}
			setIsOpenModal={(value: boolean) => {
				setIsOpen(value);
				functioToExecOnClose();
			}}
			title={t(title)}
			buttonClose={buttonClose}
		>
			<S.container data-testid={`confirmScreen-${title}`}>
				<GoAlert />

				{message}

				<S.containerBtns>
					<S.cancelBtn
						data-testid={`btnCancel-${title}`}
						onClick={() => {
							setIsOpen(false);
							functioToExecOnClose();
						}}
					>
						{t('no')}
					</S.cancelBtn>
					<S.confirmBtn
						data-testid={`btnSave-${title}`}
						onClick={() => {
							// setIsOpen(false);
							functionToExecOnConfirm();
						}}
					>
						{t('yes')}
					</S.confirmBtn>
				</S.containerBtns>
			</S.container>
		</ContainerModal>
	);
}
